class CollectionSort extends HTMLElement {
  constructor() {
    super();
    this.sortBy = document.querySelector('[data-sort-by]');
    if (this.sortBy) {
      this.sortBy.addEventListener('change', this.onSortChange.bind(this));
    }
  }

  onSortChange(event) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.href = url.href;
  }
}

customElements.define('collection-sort', CollectionSort);
